import { useSidePanel } from "@/modules/side-panel";

export const useOnFormClose = (form) => {
  const { closeSidePanel } = useSidePanel();

  const onClose = () => {
    form?.resetFields();
    closeSidePanel();
  };

  return onClose;
};
